/**
 * Geo class to handle geolocation-related functionalities.
 */
export class Geo {
  cookie = false;
  cookieSelector = 'lechameau_geolocation';

  /**
   * Constructor to initialize the Geo class and set the global window.Geo.
   */
  constructor() {
    window.Geo = this;
  }

  /**
   * Initializes the geolocation by fetching the browsing context suggestions.
   * Sets the geolocation cookie and executes the callback if provided.
   * @param {Function} [callback=false] - Optional callback function to execute after initialization.
   */
  async init(callback = false) {
    fetch(Shopify.routes.root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true').then(response => response.json()).then(json => {
      this.cookie = json;
      this.setGeolocationCookie(json);
      if (callback) callback(json);
    }).catch(error => {
      console.warn(error);
    });
  }

  /**
   * Sets the geolocation cookie in sessionStorage.
   * @param {Object} response - The geolocation data to store.
   */
  setGeolocationCookie(response) {
    sessionStorage.setItem(this.cookieSelector, JSON.stringify(response));
  }

  /**
   * Retrieves the geolocation data and initializes it if not already set.
   * @param {Function} [callback=false] - Optional callback function to execute after getting the location.
   */
  getLocation(callback = false) {
    this.cookie = this.getGeolocationCookie();
    this.init(callback);
  }

  /**
   * Retrieves the geolocation cookie from sessionStorage.
   * @returns {Object|boolean} - The geolocation cookie data or false if not found.
   */
  getGeolocationCookie() {
    const cookie = sessionStorage.getItem(this.cookieSelector);
    return cookie && JSON.parse(cookie).detected_values?.country_name ? JSON.parse(cookie) : false;
  }
}